
import { defineComponent } from '@vue/runtime-core'
import IconClose from '@/components/IconClose.vue'

export default defineComponent({
  name: 'TipDialog',
  components: { IconClose },
  setup(props, context) {
    const clickClose = () => {
      context.emit('emitClickClose')
    }
    const clickSelfBtn = () => {
      context.emit('emitClickSelfBtn')
    }

    return {
      clickClose, clickSelfBtn
    }
  }
})
